module.exports = __webpack_public_path__ + "img/icon_mark.e75b6374.png";